import { createReducer, on } from '@ngrx/store';
import * as fromOrderAction from '../actions/order.action';

export const featureKey = 'order';

export interface State {
  orderHistory: {
    data: Array<any>,
    isLoaded: Boolean
  };
}

export const initialState: State = {
  orderHistory: {
    data: [],
    isLoaded: false
  },
};

export const reducer = createReducer(
  initialState,  
  on(fromOrderAction.getOrderHistorySuccess, (state: State, props: any) => ({
    ...state,
    orderHistory: {data: props.data, isLoaded: true}
  }))
);
